package com.zq.webproject.network.model

/**
 * Author: $
 * Date: $
 * Description: $商品数据类
 */
import com.zq.webproject.model.Product
import kotlinx.serialization.Serializable

@Serializable
data class ProductResponse(
    val code: Int,
    val message:String,
    val data: List<Product>
)